import { ArchitectureOutlined, DescriptionOutlined } from "@mui/icons-material";

export default function FileIcon({ fileName }: { fileName: string }) {
    return fileName.toLowerCase().includes("drawing") ? (
        <ArchitectureOutlined />
    ) : (
        <DescriptionOutlined />
    );
}
